import React, { useContext } from 'react';
import './Product.css'
import Image from '../shared/Image';
import { useNavigate } from 'react-router-dom';
import { priceFormat } from '../../util/showPriceFormat';
import config from './../../config.json';
import preview from './../../public/image/preview.png'
import MainContext from './../../context/mainContext';
import { setPosition } from '../../util/ScrollRestoration';


const Product = ({ _id, code, name, image, price, fakePrice, inventory, info, unit, incrementalStep, comeFrom }) => {

    const navigate = useNavigate();
    const context = useContext(MainContext)
    const thisProduct = { _id, name, image, price, fakePrice, inventory, info, code, unit, incrementalStep }
    return (
        <div className='product-card'>
            <div onClick={() => {
                setPosition(`/${comeFrom === 'search' ? 'search' : 'products'}`)
                navigate(`/${comeFrom === 'search' ? 'search' : 'products'}/${_id}`, { state: { ...thisProduct } })
            }}>
                <Image
                    src={image ? `${config.api_address}/upload/${image}` : preview}
                    width={90}
                    height={90}
                    style={{ objectFit: 'cover', opacity: image ? '1' : '.5' }}
                />
                <div className='middle'>
                    <div className='title'>{name}</div>
                    {
                        (context.loggedIn && (context.loggedIn.isAdmin || (context.appSetting && !context.appSetting.negetiveInventory))) ?
                            <div className='d-flex my-1' style={{ fontSize: '.7rem' }}>
                                {
                                    inventory <= 0 ?
                                        <span className='badge bg-danger text-light'>ناموجود</span>
                                        :
                                        <>
                                            <span>موجودی</span>
                                            <span className='mx-1'>:</span>
                                            <span className={`ltr ${Number(inventory) > 0 ? 'text-muted' : 'text-danger'}`}>{inventory > 100 ? '+100' : inventory}</span>
                                            <span className={`ms-1 ${Number(inventory) > 0 ? 'text-secondary' : 'text-danger'}`}>{unit}</span>
                                        </>
                                }
                            </div> : <div className="mt-2"></div>
                    }
                    {
                        (context.loggedIn && context.loggedIn.status === 'Enable') ?
                            <div>
                                <span>قیمت</span>
                                <span className='me-1'>:</span>
                                <span className='text-success'>{priceFormat(String(price))} ریال</span>
                            </div>
                            :
                            <div style={{ maxWidth: '130px', fontSize: '.7rem' }} className='text-muted'>
                                {
                                    context.loggedIn ?
                                        `برای مشاهده ی قیمت باید عضویت شما تأیید شود`
                                        :
                                        ` برای مشاهده قیمت ابتدا وارد حساب کابری شوید`
                                }

                            </div>

                    }
                </div>
                <div className='align-self-end d-flex flex-column justify-content-center align-items-center'>
                    <button className='btn btn-sm rounded-pill btn-success d-flex align-items-center'>
                        خرید
                        <i className='fa fa-chevron-left ms-1'></i>
                    </button>
                    {
                        (context.loggedIn && (context.loggedIn.isAdmin || (context.appSetting && !context.appSetting.negetiveInventory)) && fakePrice) ?
                            <>
                                <div className='fake-price-item'>
                                    {priceFormat(String(fakePrice))}
                                </div>
                                <div className='fake-price-line'></div>
                            </>
                            :
                            <div style={{width: '1px', height:'34px'}}></div>
                    }
                </div>
            </div>
        </div>
    );
}

export default Product;